import { loadEnvironment } from 'app/app.environment';

/* The runtime config (/config.json) must be loaded before any module that
   reads `environment` is evaluated, so the actual bootstrap is pulled in via
   dynamic import only after the config resolved. */
loadEnvironment()
  .then(() => import('./bootstrap'))
  .catch((err) => {
    console.error('Failed to load runtime configuration', err);
    const message = document.createElement('p');
    message.style.cssText = 'font-family: sans-serif; margin: 2rem;';
    message.textContent =
      'Die Anwendung konnte nicht geladen werden. ' +
      'Bitte versuchen Sie es später erneut.';
    document.body.replaceChildren(message);
  });
